import React from 'react';
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const Overlay = styled.div`
    height: 100%;
    width: calc(100% - 32px);
    background-color: #595959;
    padding: 35% 16px 16px 16px;
    position: fixed;
    top: 0px;
    left: 0px; 
    animation: ${fadeIn} 0.5s ease-in-out; 
	z-index: 0;
`;

const Card = styled.div`
    background-color: #fff;
    padding: 56px 16px 40px 16px;
    width: inherit;
    border-radius: 5px;
	position: relative;
	z-index: 1;
`;

const Image = styled.img`
	width: 64px;
	height: 64px;
	position: absolute;
	top: -32px;
	left: calc(50% - 32px);
	z-index: 2;
`;

const Message = styled.p`
    margin: 0px 0px 32px 0px;
    font-family: AMX-Bold;
    font-size: 20px;
    line-height: 28px;
    color: #222222;
    text-align: center;
`;

const MainButton = styled.button`
    width: 100%;
    padding: 10.5px;
    background: #7b1fa2;
    color: #ffffff;
    font-family: AMX-Bold;
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
    border: none;
    border-radius: 56px;
`;

const ModalServicesNotWork = ({ getServices }) => {
	return (
		<Overlay>
			<Card>
				<Image src='/images/popup_alerta.png' />
				<Message>
					No fue posible cargar esta sección. 
					Por favor, inténtalo de nuevo
				</Message>
				<MainButton onClick={ getServices }>
					Intentar nuevamente
				</MainButton>
			</Card>
		</Overlay>
	)
}

export default ModalServicesNotWork